/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VisualReference } from './VisualReference';
import {
    VisualReferenceFromJSON,
    VisualReferenceFromJSONTyped,
    VisualReferenceToJSON,
    VisualReferenceToJSONTyped,
} from './VisualReference';
import type { SlpRelatedComorbidities } from './SlpRelatedComorbidities';
import {
    SlpRelatedComorbiditiesFromJSON,
    SlpRelatedComorbiditiesFromJSONTyped,
    SlpRelatedComorbiditiesToJSON,
    SlpRelatedComorbiditiesToJSONTyped,
} from './SlpRelatedComorbidities';

/**
 * 
 * @export
 * @interface MedicareSlpAssessmentForm
 */
export interface MedicareSlpAssessmentForm {
    /**
     * 
     */
    comorbidities?: Array<SlpRelatedComorbidities>;
    /**
     * 
     */
    readonly predicted_comorbidities?: Array<SlpRelatedComorbidities>;
    /**
     * 
     */
    readonly predicted_comorbidities_reasoning?: string | null;
    /**
     * 
     */
    readonly predicted_comorbidities_visual_references?: Array<VisualReference>;
    /**
     * 
     */
    has_swallowing_disorder?: boolean;
    /**
     * 
     */
    readonly predicted_has_swallowing_disorder?: boolean;
    /**
     * 
     */
    readonly predicted_has_swallowing_disorder_reasoning?: string | null;
    /**
     * 
     */
    readonly predicted_has_swallowing_disorder_visual_references?: Array<VisualReference>;
    /**
     * 
     */
    has_mechanically_altered_diet?: boolean;
    /**
     * 
     */
    readonly predicted_has_mechanically_altered_diet?: boolean;
    /**
     * 
     */
    readonly predicted_has_mechanically_altered_diet_reasoning?: string | null;
    /**
     * 
     */
    readonly predicted_has_mechanically_altered_diet_visual_references?: Array<VisualReference>;
}

/**
 * Check if a given object implements the MedicareSlpAssessmentForm interface.
 */
export function instanceOfMedicareSlpAssessmentForm(value: object): value is MedicareSlpAssessmentForm {
    return true;
}

export function MedicareSlpAssessmentFormFromJSON(json: any): MedicareSlpAssessmentForm {
    return MedicareSlpAssessmentFormFromJSONTyped(json, false);
}

export function MedicareSlpAssessmentFormFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicareSlpAssessmentForm {
    if (json == null) {
        return json;
    }
    return {
        
        'comorbidities': json['comorbidities'] == null ? undefined : ((json['comorbidities'] as Array<any>).map(SlpRelatedComorbiditiesFromJSON)),
        'predicted_comorbidities': json['predicted_comorbidities'] == null ? undefined : ((json['predicted_comorbidities'] as Array<any>).map(SlpRelatedComorbiditiesFromJSON)),
        'predicted_comorbidities_reasoning': json['predicted_comorbidities_reasoning'] === undefined ? undefined : json['predicted_comorbidities_reasoning'] === null ? null : json['predicted_comorbidities_reasoning'],
        'predicted_comorbidities_visual_references': json['predicted_comorbidities_visual_references'] == null ? undefined : ((json['predicted_comorbidities_visual_references'] as Array<any>).map(VisualReferenceFromJSON)),
        'has_swallowing_disorder': json['has_swallowing_disorder'] == null ? undefined : json['has_swallowing_disorder'],
        'predicted_has_swallowing_disorder': json['predicted_has_swallowing_disorder'] == null ? undefined : json['predicted_has_swallowing_disorder'],
        'predicted_has_swallowing_disorder_reasoning': json['predicted_has_swallowing_disorder_reasoning'] === undefined ? undefined : json['predicted_has_swallowing_disorder_reasoning'] === null ? null : json['predicted_has_swallowing_disorder_reasoning'],
        'predicted_has_swallowing_disorder_visual_references': json['predicted_has_swallowing_disorder_visual_references'] == null ? undefined : ((json['predicted_has_swallowing_disorder_visual_references'] as Array<any>).map(VisualReferenceFromJSON)),
        'has_mechanically_altered_diet': json['has_mechanically_altered_diet'] == null ? undefined : json['has_mechanically_altered_diet'],
        'predicted_has_mechanically_altered_diet': json['predicted_has_mechanically_altered_diet'] == null ? undefined : json['predicted_has_mechanically_altered_diet'],
        'predicted_has_mechanically_altered_diet_reasoning': json['predicted_has_mechanically_altered_diet_reasoning'] === undefined ? undefined : json['predicted_has_mechanically_altered_diet_reasoning'] === null ? null : json['predicted_has_mechanically_altered_diet_reasoning'],
        'predicted_has_mechanically_altered_diet_visual_references': json['predicted_has_mechanically_altered_diet_visual_references'] == null ? undefined : ((json['predicted_has_mechanically_altered_diet_visual_references'] as Array<any>).map(VisualReferenceFromJSON)),
    };
}

export function MedicareSlpAssessmentFormToJSON(json: any): MedicareSlpAssessmentForm {
    return MedicareSlpAssessmentFormToJSONTyped(json, false);
}

export function MedicareSlpAssessmentFormToJSONTyped(value?: Omit<MedicareSlpAssessmentForm, 'predicted_comorbidities'|'predicted_comorbidities_reasoning'|'predicted_comorbidities_visual_references'|'predicted_has_swallowing_disorder'|'predicted_has_swallowing_disorder_reasoning'|'predicted_has_swallowing_disorder_visual_references'|'predicted_has_mechanically_altered_diet'|'predicted_has_mechanically_altered_diet_reasoning'|'predicted_has_mechanically_altered_diet_visual_references'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'comorbidities': value['comorbidities'] == null ? undefined : ((value['comorbidities'] as Array<any>).map(SlpRelatedComorbiditiesToJSON)),
        'has_swallowing_disorder': value['has_swallowing_disorder'],
        'has_mechanically_altered_diet': value['has_mechanically_altered_diet'],
    };
}

